import { render, staticRenderFns } from "./inspectVideo.vue?vue&type=template&id=0b4f381c"
import script from "./inspectVideo.vue?vue&type=script&lang=js"
export * from "./inspectVideo.vue?vue&type=script&lang=js"
import style0 from "./inspectVideo.vue?vue&type=style&index=0&id=0b4f381c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports